export type UploadMessages = ReturnType<typeof getUploadMessages>;

export const getUploadMessages = () => ({
  uploadArea: {
    clickOrDrag: "点击或将 PDF 拖至窗口上传",
    limitHint: (type: string, maxCount: number, maxSize: number) =>
      `上传限制：${type}最多 ${maxCount} 个，单个最大支持 ${maxSize}MB`,
    dropToUpload: "上传到此处",
    dragFilesOrFolder: (accepts: string) => `拖动 PDF 文件或文件夹到此处上传（支持批量上传）`,
    urlDragNotSupported: "URL拖拽上传暂不支持，请使用URL上传功能",
    single: "单次",
    total: "累计",
  },
  buttons: {
    localUpload: "本地上传",
    folderUpload: "文件夹上传",
    uploadByFile: "按文件上传",
    uploadByFolder: "按文件夹上传",
    importFromLibrary: "从文献库导入",
    urlUpload: "URL上传",
    uploading: "文献上传中...",
    import: "导入文献",
    uploadFile: "上传文献",
  },
  errors: {
    formatInvalid: "非 PDF 格式文件，无法上传",
    sizeExceeded: (maxSize: number) => `文件超出大小限制 ${maxSize}MB`,
    countExceeded: (max: number, remaining: number) => `累计超过 ${max} 篇（本次可选 ${remaining} 篇），请重选！`,
    singleCountExceeded: (max: number) => `单次上传最多不超过 ${max} 个文献`,
    duplicate: "重复文献，已自动合并",
    balanceInsufficient: "飞豆余额不足，请先充值后再上传",
    uploadFailed: "文献上传失败，请重试",
    partialFailed: "上传完成，部分异常",
    validationSummary: (count: number) => `${count}个文件校验失败，请查看详情`,
    noFilesInFolder: "文件夹中没有找到符合要求的文献",
    fileOnlyMode: "当前仅支持文件上传，请不要选择文件夹",
    folderOnlyMode: "当前仅支持文件夹上传，请重新选择文件夹",
    sessionNotReady: "上传会话尚未准备完成，请稍后重试",
    cancelled: "上传取消",
  },
  progress: {
    uploading: "上传中",
    success: "上传成功",
    partialFailed: "上传完成，部分异常",
    allFailed: "上传失败",
    uploadingDetail: "上传中...",
    successDetail: "上传成功",
    failedDetail: "上传失败",
    expand: "展开详情",
    collapse: "折叠详情",
    clearAndClose: "清空并关闭",
    doNotCloseOrRefresh: "上传过程中请勿关闭或刷新页面",
  },
  url: {
    placeholder: "输入 PDF 文献网址链接快速上传",
    submit: "提交",
    fetching: "PDF 资源获取中，请稍等...",
    invalidUrl: "PDF URL 地址格式错误",
    fetchFailed: "PDF 获取失败，请检查 PDF URL 地址",
  },
  vipUpgrade: {
    title: "升级 Plus 会员可支持 AI Max「Deep」 模式",
    content: (max: number, vipMax: number) => `当前可导入最多 ${max} 篇文献，升级 Plus 会员后使用 AI Max「Deep」 模式最多可导入 ${vipMax} 篇文献。`,
    reselect: "重选",
  },
  common: {
    close: "关闭",
    zoteroGuide: "Zotero 快速上传指南",
  },
});

